module.exports = __webpack_public_path__ + "img/qq.885ca5ff.png";